import { render, staticRenderFns } from "./choosePersonDialog.vue?vue&type=template&id=13420270&scoped=true&"
import script from "./choosePersonDialog.vue?vue&type=script&lang=ts&"
export * from "./choosePersonDialog.vue?vue&type=script&lang=ts&"
import style0 from "./choosePersonDialog.vue?vue&type=style&index=0&id=13420270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13420270",
  null
  
)

export default component.exports